export const JWT_LOCAL_STORAGE_KEY = 'otp_jwt_token';
export const IMPERSONATOR_JWT_LOCAL_STORAGE_KEY = 'otp_impersonator_jwt_token';
export const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL;
